import { Grid, Stack, Typography } from "@mui/material";
import {
  FormGetField,
  FormGetResponse,
  FormsGetResponse,
} from "../../models/Form";
import dayjs from "dayjs";

const EQ5D5LDayList = <T extends FormsGetResponse>({
  items,
}: {
  items: T[];
}) => {
  const sortedItems = items
    .filter((a) => a.values.length > 0)
    .sort((a, b) => {
      const dateA = dayjs(
        (a as unknown as FormGetResponse).values.find(
          (a) => a.fieldAlias === "D_EQ5D_Datum"
        )?.value
      ).valueOf();
      const dateB = dayjs(
        (b as unknown as FormGetResponse).values.find(
          (a) => a.fieldAlias === "D_EQ5D_Datum"
        )?.value
      ).valueOf();
      return dateB - dateA;
    });
  return (
    <>
      {sortedItems?.map((item, index) => {
        const values = item.values as unknown as FormGetField[];
        const date = values.find((a) => a.fieldAlias === "D_EQ5D_Datum")?.value;
        const total = values.find(
          (a) => a.fieldAlias === "D_EQ5D_6_VAS"
        )?.value;
        const rorlighet = values.find(
          (a) => a.fieldAlias === "D_EQ5D_1_Rorlighet"
        )?.value;
        const hygien = values.find(
          (a) => a.fieldAlias === "D_EQ5D_2_Hygien"
        )?.value;
        const huvudsakliga_aktiviteter = values.find(
          (a) => a.fieldAlias === "D_EQ5D_3_HuvudsakligaAktiviteter"
        )?.value;
        const smartor = values.find(
          (a) => a.fieldAlias === "D_EQ5D_4_Smartor"
        )?.value;
        const oro = values.find((a) => a.fieldAlias === "D_EQ5D_5_Oro")?.value;
        return (
          <Grid
            container
            key={`${item[index]?.clientFormId}-${index}`}
            p={2}
            sx={{ borderBottom: "1px solid lightgrey" }}
            spacing={2}
          >
            <Grid item xs={12} sm={3}>
              <Typography sx={{ paddingBottom: 2 }}>
                {date ? dayjs(date).format("YYYY-MM-DD") : "-"}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Stack direction="column">
                <Typography>
                  <b>Självuppskattat hälsotillstånd: </b>
                  {total}
                </Typography>
                <Typography>
                  <b>Rörlighet: </b>
                  {rorlighet}
                </Typography>
                <Typography>
                  <b>Hygien: </b>
                  {hygien}
                </Typography>
                <Typography>
                  <b>Huvudsakliga aktiviteter: </b>
                  {huvudsakliga_aktiviteter}
                </Typography>
                <Typography>
                  <b>Smärtor: </b>
                  {smartor}
                </Typography>
                <Typography>
                  <b>Oro: </b>
                  {oro}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        );
      })}
    </>
  );
};

export default EQ5D5LDayList;
